<template>
  <div>
    <div class="flex flex-col p-3">
      <div class="pb-3 flex justify-between items-center w-full">
        <el-row class="w-full pb-3" :gutter="10">
          <el-col :span="6" >
            <el-input placeholder="search song name" v-model="filters" @change="searchMusic" ></el-input>
          </el-col>
          <el-col  :span="6" class="flex items-center">
            <Button @clicked="searchMusic" label="Apply"/>
            <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetMusic" /></button>
          </el-col>
        </el-row>
      </div>
      <el-row class="pb-3 w-full" >
        <el-col :span="24" class="flex flex-row gap-3" >
          <div @click="filterStatus = 0" class="md:w-50 ">
            <div v-bind:class="filterStatus == 0? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium">
                Waiting for Review ({{countWaitingForReviewByArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 1" class="md:w-40 ">
            <div v-bind:class="filterStatus == 1? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium">
                Under Review ({{countUnderReviewByArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 2" class="md:w-40 ">
            <div v-bind:class="filterStatus == 2? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium">
                Approved ({{countApprovedByArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 3" class="md:w-40 ">
            <div v-bind:class="filterStatus == 3? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium ">
                Rejected ({{countRejectedByArtist}})
              </p>
            </div>
          </div>
          <div @click="filterStatus = 4" class="md:w-40 ">
            <div v-bind:class="filterStatus == 4? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
              <p class="m-auto text-xs font-medium ">
                Published ({{countPublishedByArtist}})
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
      <data-tables-server ref="tableMusic" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [20] }" @query-change="onChangeTable" >
        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
        </el-table-column>
        <el-table-column  label="Publish" class="text-center" width="90px">
          <template slot-scope="scope">
            {{ scope.row.published ? 'Published' : 'Not Published' }}
          </template>
        </el-table-column>
        <el-table-column  label="Song" width="250px" >
          <template slot-scope="scope">
            <audio controls :src="scope.row.file" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
              Audio tag not supported
            </audio>
          </template>
        </el-table-column>
        <el-table-column label="Actions" width="120px" fixed="right" >
          <template slot-scope="scope">
            <div class="static inline-block text-left container-action">
                  <span  class="rounded-md shadow-sm">
                    <div class="py-1" >
                      <VueCustomTooltip label="Detail" :position="'is-right'">
                        <button class="p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" @click="detail($event,scope.row)">
                          <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                        </button>
                      </VueCustomTooltip>
                      <VueCustomTooltip label="Edit" :position="'is-left'">
                        <button  @click="isShowModalEdit = true;editSong = scope.row" class="p-2 w-8 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                          <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                        </button>
                      </VueCustomTooltip>
                    </div>
                  </span>
            </div>
          </template>
        </el-table-column>
      </data-tables-server>
    </div>
    <ModalDialogDetail
      ref="detailSong"
      :isShowingModal="isShowingDetailModal"
      :isLoading="isLoading"
      title="Song Details"
      @toggleModal="isShowingDetailModal = !isShowingDetailModal"
    >
      <template slot="body" >
        <SongDetail :toggle-reset="isShowingDetailModal" :song="song"></SongDetail>
      </template>
    </ModalDialogDetail>
    <ModalDialog
      ref="addSongModal"
      :isShowingModal="isShowModalAdd"
      :label-submit="`Submit`"
      title="Add Song"
      @toggleModal="isShowModalAdd = !isShowModalAdd"
      @save="submit()"
    >
      <template slot="body" >
        <AddSong ref="addSong" @on-submit-song="onSubmitSong" :toggle-reset="isShowModalAdd" :user-id="artistid" :musicverse-cut="musicverseCut" :artist-cut="artistCut"></AddSong>
      </template>
    </ModalDialog>
    <ModalDialog
      ref="EditSongModal"
      :isShowingModal="isShowModalEdit"
      :label-submit="`Save`"
      title="Edit Song"
      @toggleModal="isShowModalEdit = !isShowModalEdit"
      @save="submitEdit()"
    >
      <template slot="body" >
        <EditSong ref="editSong" @on-edit-song="onSubmitEditSong" :toggle-reset="isShowModalEdit" :song="editSong" :user-id="artistid" :musicverse-cut="musicverseCut" :artist-cut="artistCut"></EditSong>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import ModalDialog from '../../components/Common/ModalDialog';
import ModalDialogDetail from '../../components/Common/ModalDialogDetail';
import AddSong from '../../views/contents/AddSong';
import EditSong from '../../views/contents/EditSong';
import SongDetail from '../../views/contents/SongDetail';
import { Button } from '@/components/Layout/Form';
import AddAlbum from '@/views/Album/AddAlbum.vue';
import EditAlbum from '@/views/Album/EditAlbum.vue';
import DetailAlbum from '@/views/Album/DetailAlbum.vue';

const API_URL = process.env.API_URL;

export default {
  name: 'ListSong',
  mixins: [validationMixin],
  props: {
    artistid: {
      type: Number,
    },
    toggleReset: {
      type: Boolean,
    },
    musicverseCut: {
      type: Number,
    },
    artistCut: {
      type: Number,
    },
  },
  data() {
    return {
      isShowingDetailModal: false,
      id: null,
      filterStatus: 0,
      filter: {
        status: 0,
        page: 1,
        per_page: 20,
        sortby: 'id',
        sortorder: 'asc',
        q: '',
        u: '',
      },
      displayItems: 20,
      data: [],
      total: 0,
      filters: '',
      filterName: '',
      song: {
        cover: '',
        title: '',
        genre: '',
        year: '',
        file: '',
        language: '',
        copyright: null,
      },
      editSong: {},
      isShowModalAdd: false,
      isShowModalEdit: false,
    };
  },
  async mounted() {
    this.id = this.artistid;
    const sortby = 'id';
    const sortorder = 'desc';
    await this.requestListGenreSong();
    // await this.requestListSongByArtist(Object.assign(this.filter, { sortby, sortorder }),this.artistid);
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading']),
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('SongModule', [
      'listSongArtist',
      'countWaitingForReviewByArtist',
      'countUnderReviewByArtist',
      'countApprovedByArtist',
      'countRejectedByArtist',
      'countPublishedByArtist',
    ]),
    titles() {
      return [{
        prop: 'title',
        label: 'Song Name',
      }, {
        prop: 'artist',
        label: 'Artist Name',
      }, {
        prop: 'elapsed_day',
        label: 'Elapsed Day',
      }, {
        prop: 'status',
        label: 'Status',
      }];
    },
  },
  watch: {
    artistid: {
      immediate: true,
      async handler(val) {
        // await this.searchMusic();
      },
    },
    listSongArtist: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
    toggleReset: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        // console.log('toggle reset',val)
        if (val) {
          this.data = [];
          this.total = 0;
          this.filter = {
            status: 0,
            page: 1,
            per_page: 20,
            sortby: 'id',
            sortorder: 'asc',
            q: '',
            u: '',
          };
          this.filterStatus = 0;
          this.filters = '';
          this.filterName = '';
          await this.searchMusic();
        }
      },
    },
    filterStatus: {
      immediate: true,
      async handler(newval, oldval) {
        if (typeof (oldval) === 'undefined') return;
        if (newval !== oldval) {
          const data = { id: this.artistid };
          if (newval == 0) {
            const sortby = 'id';
            const sortorder = 'asc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          } else {
            const sortby = 'status_updated_at';
            const sortorder = 'desc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          }
          const filter = Object.assign(this.filter, { status: newval });
          await this.requestListSongByArtist({
            filter, data,
          });
          // await this.requestListSongByArtist(Object.assign(this.filter, { status: newval }),this.artistid);
        }
      },
    },
  },
  methods: {
    ...mapActions('SongModule', [
      'requestListSongByArtist',
      'requestDetailSubmission',
      'requestListGenreSong',
    ]),
    async refineData() {
      if (this.listSongArtist.length !== 0) {
        this.total = this.listSongArtist.total;
        if (typeof (this.listSongArtist.data) === 'undefined') return;
        this.data = await Promise.all(this.listSongArtist.data.map(async (song) => {
          let status = '';
          switch (song.status) {
            case 1:
              status = 'Under Review';
              break;
            case 2:
              status = 'Approved';
              break;
            case 3:
              status = 'Rejected';
              break;
            case 4:
              status = 'Published';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Waiting for Review';
              break;
          }
          const file = await this.getMusicFile(song.file);
          // const canDelete = song.status!==2 || song.published!==1;
          return Object.assign(
            {},
            song,
            {
              status,
              statusCode: song.status,
              album: '-',
              file,
              elapsed_day: `${song.elapsed_day} ${song.elapsed_day > 1 ? 'days' : 'day'}`,
              // canDelete
            },
          );
        }));
      }
    },
    async searchMusic() {
      const data = { id: this.artistid };
      const filter = Object.assign(this.filter, { q: this.filters, u: this.filterName });
      await this.requestListSongByArtist({
        filter, data,
      });
    },
    async resetMusic() {
      this.$refs.tableMusic.$refs.elTable.clearSort();
      this.filters = '';
      await this.searchMusic();
    },
    async getMusicFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileAudio = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
      });
      return fileAudio.data;
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = this.isAdmin ? 'submission_date' : 'id';
      }
      if (this.filterStatus == 0) {
        sortby = 'id';
        sortorder = 'asc';
      } else {
        sortby = 'status_updated_at';
        sortorder = 'desc';
      }
      this.filter = Object.assign(this.filter, { sortorder, sortby, page });
      const data = { id: this.artistid };
      await this.requestListSongByArtist({
        filter: this.filter, data,
      });
    },
    async detail(event, row) {
      this.song = row;
      this.isShowingDetailModal = !this.isShowingDetailModal;
    },
    async submit() {
      await this.$refs.addSong.submit();
    },
    async submitEdit() {
      await this.$refs.editSong.submit();
    },
    async onSubmitSong(state) {
      this.isShowModalAdd = false;
      await this.searchMusic();
    },
    async onSubmitEditSong(state) {
      this.isShowModalEdit = false;
      await this.searchMusic();
    },
    edit(event, row) {
      console.log('detail', row);
    },
  },
  components: {
    DetailAlbum, EditAlbum, AddAlbum,
    VueCustomTooltip,
    ModalDialog,
    ModalDialogDetail,
    AddSong,
    EditSong,
    SongDetail,
    Button
  },
};
</script>

<style scoped>
  .mx-500{
    max-height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Artist/ListSong.vue